// extracted by mini-css-extract-plugin
export default {"page":"AuthLayout_page__mf3fV","cover":"AuthLayout_cover__pysmD","wrap":"AuthLayout_wrap__9F6NU","content":"AuthLayout_content__bG-nz","logo":"AuthLayout_logo__SGnd2"};